import React, {FunctionComponent} from 'react';

export const SingleTokenPriceInput: FunctionComponent<{
  title: string;
  tokenName: string;
  tokenAmount: string;
  placeholder?: string;
  step?: string;
  className?: string;
  onChange: (amount: string) => void;
}> = ({title, tokenName, tokenAmount, onChange, placeholder = '0', step = '0.000001', className = ''}) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div
      className={`relative px-3 py-2 bg-gray-900 rounded-xl text-white border border-graybluedark focus-within:border-deepblue ${className}`}
    >
      <div className='uppercase text-sm font-semibold text-white'>{title}</div>
      <div className='flex justify-between'>
        <div className='text-sm font-semibold text-gray-400'>{tokenName}</div>
        <div>
          <input
            className='absolute top-0 left-0 w-full h-full p-4 pl-20 pr-3 rounded-xl bg-transparent text-gray-300 text-3xl text-right appearance-none outline-0'
            onChange={onInputChange}
            placeholder={placeholder}
            min='0'
            step={step}
            value={tokenAmount}
            type='number'
          />
        </div>
      </div>
    </div>
  );
};
